import * as React from 'react'

function SvgScratch2Icon(props) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path
        d="M11.992 7.5c-2.389 0-4.786.326-7.887.989a.5.5 0 0 1-.21-.978C7.035 6.84 9.508 6.5 11.994 6.5c2.485 0 4.963.34 8.111 1.011a.5.5 0 1 1-.208.978c-3.112-.662-5.514-.989-7.904-.989ZM20.907 12.491c-6.981-1.32-10.856-1.322-17.814 0a.5.5 0 1 1-.186-.982c7.081-1.346 11.082-1.344 18.186 0a.5.5 0 0 1-.186.982ZM4.105 16.489c3.101-.663 5.498-.99 7.887-.989 2.39 0 4.792.327 7.904.989a.5.5 0 1 0 .208-.978c-3.148-.67-5.626-1.01-8.111-1.011-2.486 0-4.959.34-8.097 1.011a.5.5 0 1 0 .209.978Z"
        fill="#E91630"
      />
    </svg>
  )
}

export default SvgScratch2Icon
